import axios from './axiosConfig';

const api = {
    // 获取所有工作地点
    listAllArea: () => axios.get('/area/listAreas')
};
export default api;
